const DEFAULT_BASE_URL = 'http://localhost:3000';

export const API_BASE_URL: string =
  process.env.EXPO_PUBLIC_API_BASE_URL?.trim() || DEFAULT_BASE_URL;

export const API_DEFAULT_TIMEOUT_MS = 15_000;

export const HEADERS = {
  authorization: 'Authorization',
  contentType: 'Content-Type',
  idempotencyKey: 'Idempotency-Key',
  retryAfter: 'Retry-After',
  capabilities: 'X-MP-Capabilities',
} as const;

/**
 * Server-gated features this build can render. The backend hides content a
 * build can't handle (e.g. Voltr deals) unless the client declares it here.
 */
export const CLIENT_CAPABILITIES = ['voltr'] as const;

export const SUPPORT_EMAIL = 'jason@marketpryce.com';

export const LINKS = {
  support: `mailto:${SUPPORT_EMAIL}`,
  privacy: process.env.EXPO_PUBLIC_PRIVACY_URL?.trim() || 'https://www.marketpryce.com/privacy-policy',
  terms: process.env.EXPO_PUBLIC_TERMS_URL?.trim() || 'https://www.marketpryce.com/terms-conditions',
} as const;

export const SECURE_STORE_KEYS = {
  sessionToken: 'mp_session_token',
  pendingRef: 'mp_pending_ref',
  pendingIdempotencyKey: 'mp_pending_idempotency_key',
  // Device-global "have we shown the push priming screen yet" flag. Not a
  // secret; SecureStore is just the only persistent KV available without
  // adding a native module (would break OTA — not in the shipped build).
  pushPrimed: 'mp_push_primed',
  // Device-global "have we asked for an App Store review yet" flag.
  reviewRequested: 'mp_review_requested',
} as const;
